module.exports = __webpack_public_path__ + "static/media/soda-15-logo.fff5fc92.svg";